module.exports = __webpack_public_path__ + "img/sos-type-red.11757f8b.png";